exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host .container-fuild{display:flex;flex-wrap:wrap;color:#fff;background-color:#a00313}:host .exclamation-icon{font-size:80px;text-align:center;justify-content:center;width:7%}:host .exclamation-icon>i{position:relative;top:calc(50% - 60px)}:host .adblock-warning-title{margin:1.5%;float:left;font-family:Open Sans,sans-serif;font-weight:700}:host .adblock-warning-text{margin:1.5%}@media screen and (max-width:1183px){:host .container-fuild{display:flex;flex-direction:column}:host .exclamation-icon{width:100%;text-align:center}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/shared/components/adblocker-detector/adblocker-detector.component.scss
// module id = 721
// module chunks = 0